import React, { FC } from 'react';

import { AuthPageWrapper } from '../AuthPageLayout';
import { FinishRegistration } from 'features';

/**
 * Component representing the registration page.
 *
 * @returns A React functional component that renders the registration page layout
 *          and the finish registration form.
 */
export const Registration: FC = () => {
  return (
    <AuthPageWrapper>
      <FinishRegistration />
    </AuthPageWrapper>
  );
};
